<template>
  <div class="loading-screen"><i></i><i></i><i></i><i></i></div>
</template>

<script>
export default {
  name: "LoadingAnimation",
  props: {
    name: {
      type: String,
      default: "",
    },
  },
};
</script>
